import React from 'react';
import {
  ProductDimension as D,
  ProductDimensionShape as S,
  ProductDimensionsProductTypePrefixes,
  ProductDimensionTypes as T,
  ProductDimensionValue as V
} from '../../../../../types';
import ProductStyle from '../style/style';

const { productCode, productDimensions, productDimensionsProductType } = window.globalProductDetails;

const watchRangeOrRingProduct =
  productDimensionsProductType === ProductDimensionsProductTypePrefixes.WATCH_RANGE ||
  productDimensionsProductType === ProductDimensionsProductTypePrefixes.RING;

const caseSizeAndCaratWeightDimensions = (dimension: D): boolean =>
  dimension.type === T.CASE_SIZE || dimension.type === T.DIAMOND_CARAT_WEIGHT;

const colourSwatchDimensions = (dimension: D): boolean => dimension.type === T.SWATCH;

const caseSizeByProductCode = (caseSize: V): S | undefined =>
  caseSize.products.find((product) => product.code === productCode);

const allSameSizeProductsIntoOneArray =
  (selectedProductSize?: string) =>
  (dimensionShapes: S[], dimensionValue: V): S[] =>
    dimensionValue.value === selectedProductSize ? [...dimensionShapes, ...dimensionValue.products] : dimensionShapes;

const allProductsIntoOneArray =
  () =>
  (dimensionShapes: S[], dimensionValue: V): S[] =>
    [...dimensionShapes, ...dimensionValue.products];

const availableForPurchaseOrCurrentProduct = (shape: S): boolean => shape.code === productCode || shape.enabled;
const byName = (a: S, b: S): number => a.colourSwatch?.name.localeCompare(b.colourSwatch?.name || '') || 1;
const byIsSelectedFirst = (shape: S): number => (shape.code === productCode ? -1 : 1);
const renderProductStyleComponent = (s: S): React.ReactElement => <ProductStyle key={s.code} productData={s} />;

const selectedProductSize = productDimensions
  ?.find(watchRangeOrRingProduct ? caseSizeAndCaratWeightDimensions : colourSwatchDimensions)
  ?.values.find(caseSizeByProductCode)?.value;

const sameSizeProducts = productDimensions
  ?.find(watchRangeOrRingProduct ? caseSizeAndCaratWeightDimensions : colourSwatchDimensions)
  ?.values.reduce(
    watchRangeOrRingProduct ? allSameSizeProductsIntoOneArray(selectedProductSize) : allProductsIntoOneArray(),
    []
  );

const allProducts = sameSizeProducts?.filter(availableForPurchaseOrCurrentProduct).sort(byName).sort(byIsSelectedFirst);

function Styles(): React.ReactElement {
  return <>{allProducts?.map(renderProductStyleComponent)}</>;
}

export default Styles;
